export default function FloatingSocials() {
  return (
    <div
      className="floating_social_link"
      style={{
        background: "rgba(43, 99, 114, 1)",
        borderRadius: "20px 0 0 20px",
        position: "fixed",
        top: "50%",
        right: 0,
        width: "auto",
        height: "auto",
        zIndex: 99,
        transform: "translateY(-50%)",
      }}
    >
      <ul
        style={{
          padding: "10px 4px 10px 10px",
          margin: 0,
          listStyle: "none",
        }}
      >
        {[
          {
            href: "https://www.facebook.com/share/1AXSfjB69v/?mibextid=wwXIfr",
            src: "/img/icons/facebook_logo.png",
            alt: "Facebook",
          },
          {
            href: "https://www.instagram.com/intronlifesciences22?igsh=amRjcXg5bXlleXI5",
            src: "/img/icons/insta_logo.png",
            alt: "Instagram",
          },
          {
            href: "https://x.com/intronl?s=21",
            src: "/img/icons/twitter_logo.png",
            alt: "Twitter",
          },
          {
            href: "https://www.threads.com/@intronlifesciences22?igshid=NTc4MTIwNjQ2YQ==",
            src: "/img/icons/social_logo.png",
            alt: "Threads",
          },
          {
            href: "https://www.youtube.com/@IntronLifeSciencesIndia",
            src: "/img/icons/youtube_logo.png",
            alt: "YouTube",
          },
          {
            href: "https://www.linkedin.com/company/intron-life-sciences-private-limited/",
            src: "/img/icons/linkedin_logo.png",
            alt: "LinkedIn",
          },
          {
            href: "https://wa.me/918801230123",
            src: "/img/icons/whatsapp_icon_floating.png",
            alt: "WhatsApp",
          },
        ].map(({ href, src, alt }, index, arr) => (
          <li
            key={alt}
            style={{
              marginTop: index === 0 ? 4 : 8,
              marginBottom: 8,
              borderBottom:
                index !== arr.length - 1
                  ? "1px solid rgba(255, 255, 255, 0.47)"
                  : undefined,
              paddingBottom: index !== arr.length - 1 ? 12 : undefined,
            }}
          >
            <a href={href} target="_blank" rel="noopener noreferrer">
              <img
                src={src}
                alt={alt}
                style={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
